"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MessageBarTitle", {
    enumerable: true,
    get: function() {
        return MessageBarTitle;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useMessageBarTitle = require("./useMessageBarTitle");
const _renderMessageBarTitle = require("./renderMessageBarTitle");
const _useMessageBarTitleStylesstyles = require("./useMessageBarTitleStyles.styles");
const MessageBarTitle = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useMessageBarTitle.useMessageBarTitle_unstable)(props, ref);
    (0, _useMessageBarTitleStylesstyles.useMessageBarTitleStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useMessageBarTitleStyles_unstable')(state);
    return (0, _renderMessageBarTitle.renderMessageBarTitle_unstable)(state);
});
MessageBarTitle.displayName = 'MessageBarTitle';
